<template>
    <div class="relative h-1.5 md:h-2 flex flex-col justify-center">
        <div class="h-px bg-dust"></div>

        <div
            :style="{ width: `${totalProgress}%` }"
            class="absolute rounded-r-xl h-full bg-shine transition-all duration-500 ease-out"
        >
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        computed: {
            totalProgress() {
                let totalProgress = this.selectionProgress;

                if (this.isMobile) {
                    totalProgress = this.stepProgress;
                }

                return totalProgress;
            },

            controllerState() {
                return this.customizerStore.viewController?.state;
            },

            allGroups() {
                return this.customizerStore.viewController?.blueprint.groups;
            },

            allSteps() {
                // eslint-disable-next-line max-len
                return this.allGroups?.filter((group) => group.custom['oe-is-step'] === 'true' && group.custom['oe-hide'] !== 'true');
            },

            totalSteps() {
                return this.allSteps?.length;
            },

            currentStep() {
                return this.appStore.currentStep.split('select')[1];
            },

            selectedOptions() {
                // eslint-disable-next-line max-len
                return this.controllerState?.filter((x) => !x.component.placeholder && x.placement.custom['widget-type'] !== 'personalization' && x.placement.code !== 'Proof') || [];
            },

            selectionProgress() {
                const totalSelectionsMade = this.selectedOptions.length;

                return Math.round((totalSelectionsMade / this.totalSteps) * 100);
            },

            stepProgress() {
                const index = this.allSteps?.findIndex((step) => step.name === this.currentStep);
                const currentStepProgress = index + 1;

                return Math.round((currentStepProgress / this.totalSteps) * 100);
            },

            isMobile() {
                return this.appStore.isMobile;
            },
        },
    };
</script>
